import React, { useEffect } from 'react';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { Solution } from '../components/sections/Solution';
import { Pricing } from '../components/sections/Pricing';
import { Footer } from '../components/sections/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on mount
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-amber-500/30" data-id="element-209">
      <Hero data-id="element-210" />
      <Problem data-id="element-211" />
      <Solution data-id="element-212" />
      <Pricing data-id="element-213" />
      <Footer data-id="element-214" />
    </div>;
}